import { render, staticRenderFns } from "./QImpersonateBanner.vue?vue&type=template&id=5714a5e8&scoped=true&"
import script from "./QImpersonateBanner.vue?vue&type=script&lang=js&"
export * from "./QImpersonateBanner.vue?vue&type=script&lang=js&"
import style0 from "./QImpersonateBanner.vue?vue&type=style&index=0&id=5714a5e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5714a5e8",
  null
  
)

export default component.exports